var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m83.377 31.952v51.385c0 4.785-3.879 8.664-8.664 8.664h-53.427c-4.785 0-8.664-3.879-8.664-8.664v-70.673c.001-4.785 3.879-8.664 8.664-8.664h35.784z",
    fill: "#ff6f01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.377 31.952h-20.531c-3.19 0-5.776-2.586-5.776-5.776v-22.176z",
    fill: "#f9a64b"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.058 52.837h4.146v11.834c0 1.1-.254 2.076-.761 2.939-.513.857-1.224 1.529-2.132 2.002-.914.474-1.929.711-3.051.711-1.878 0-3.339-.474-4.383-1.421-1.043-.948-1.562-2.29-1.562-4.027h4.168c0 .79.135 1.359.406 1.715.276.355.728.536 1.371.536.575 0 1.021-.214 1.331-.649.31-.429.468-1.032.468-1.805v-11.835z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.978 64.231v5.855h-4.157v-17.249h6.881c1.32 0 2.487.243 3.503.728 1.015.485 1.799 1.179 2.358 2.076.553.897.835 1.912.835 3.051 0 1.681-.604 3.023-1.811 4.033-1.201 1.004-2.854 1.506-4.958 1.506zm0-3.21h2.724c.807 0 1.421-.197 1.844-.604.423-.4.632-.97.632-1.703 0-.807-.22-1.45-.654-1.935-.434-.479-1.027-.722-1.777-.733h-2.769z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.726 67.954c-.637.711-1.574 1.28-2.809 1.715-1.23.434-2.578.654-4.05.654-2.256 0-4.061-.694-5.409-2.076-1.354-1.382-2.076-3.305-2.172-5.765l-.011-1.495c0-1.698.299-3.181.902-4.45.598-1.263 1.455-2.239 2.578-2.922 1.117-.682 2.408-1.027 3.875-1.027 2.149 0 3.819.491 5.009 1.478 1.184.981 1.878 2.448 2.076 4.4h-4.005c-.141-.965-.451-1.653-.925-2.064s-1.145-.615-2.014-.615c-1.038 0-1.844.44-2.414 1.326s-.857 2.149-.863 3.79v1.043c0 1.72.293 3.018.88 3.881.592.863 1.517 1.297 2.781 1.297 1.077 0 1.884-.243 2.414-.722v-2.679h-2.888v-2.854h7.045z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.b4ab7223f4152442df1e0cf74fb8ac99.svg";
export { ForwardRef as ReactComponent };